import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from "./Button.css.js";
// Props-in / events-out. A native <button> styled by the theme tokens.
export const Button = ({ variant = "primary", size = "md", type = "button", children, ...rest }) => (_jsx("button", { type: type, className: [styles.base, styles.variant[variant], styles.size[size]].join(" "), ...rest, children: children }));
//# sourceMappingURL=Button.js.map